<template>
  <div v-if="summary" class="g-box">
    <link rel="stylesheet" href="/css/S-01.css">
    <!--ぱんくず-->
    <breadcrumb :pathList="pathList">
    </breadcrumb>
    <!--/ぱんくず-->
    <main class="g-content">
      <!--controls-->
      <div class="control g-rainbow">
        <p v-if="go_back_to" class="control_back">
          <router-link class="g-link" :to="go_back_to | lang">
            <i class="g-i g-i-back" aria-hidden="true"></i>{{ $t("Detail.back_to_list") }}
          </router-link>
        </p>
        <p v-if="summary.navigation" class="control_prev">
          <router-link v-if="summary.navigation.prev" class="g-link" :to="'/detail/'+summary.navigation.prev | lang">
            <i class="g-i g-i-arrow" aria-hidden="true"></i>{{ $t("Detail.go_to_prev") }}
          </router-link>
        </p>
        <p v-if="summary.navigation" class="control_total">{{ $t("Detail.total_count", { count: total }) }}</p>
        <p v-if="summary.navigation" class="control_next">
          <router-link v-if="summary.navigation.next" class="g-link" :to="'/detail/'+summary.navigation.next | lang">
            {{ $t("Detail.go_to_next") }}<i class="g-i g-i-arrow" aria-hidden="true"></i>
          </router-link>
        </p>
      </div>
      <!--/controls-->
      <!--情報エリア-->
      <div class="infoArea">
        <!--画像ギャラリー-->
        <galleryCarousel v-if="summary.images" :images="this.summary.images" @parentFunc="openZoomModal"></galleryCarousel>
        <!--/画像ギャラリー-->
        <!--詳細情報-->
        <div v-if="summary.fields" class="detail">
          <h1 class="detail_h">{{ summary.fields.__title__ | join}}</h1>
          <table v-if="summary_fields" class="detail_data">
              <tr v-for="(value, name, index) in summary_fields" :key="index">
                <th>{{ $t('Detail.Summary_fields.'+name) }}</th>
                <td v-html="join(value)"></td>
              </tr>
          </table>
        </div>
        <!--/詳細情報-->
        <!--関連する索引語-->
        <div class="secondary">
          <p class="g-h-2 g-h-sm">{{ $t('Detail.related_index') }}</p>
          <ul class="g-list g-list-link">
            <li v-for="(rindex, index) in related_index" :key="index"><a @click="getSearchResult(rindex.field, rindex.value)">{{ rindex.value | join }}</a></li>
          </ul>
        </div>
        <!--/関連する索引語-->
        <!--データベース一覧-->
        <div class="secondary">
          <p class="g-h-2 g-h-sm db_title">{{ $t('Detail.database_list') }}</p>
          <!--ボタンの数・並びは「データベース選択」エリアのボタンと一致させてください-->
          <ul class="db_anchors">
            <li v-for="(value, index) in related_db" :key="index">
              <button class="g-btn g-btn-sm g-btn-anchor" type="button">{{value }}<i class="g-i g-i-arrow" aria-hidden="true"></i></button>
            </li>
          </ul>
        </div>
        <!--/データベース一覧-->
      </div>
      <!--/情報エリア-->


      <!--データベース-->
      <div class="db" id="db">
        <p class="db_h">{{ $t('Detail.select_database') }}</p>
        <!--DB一覧-->
        <div class="db_list g-rainbow">
          <!--↓↓最初のaタグはaria-selected="true"にしてください-->
          <!--↓↓href属性に、対応するタブパネルのIDを指定します（同じものをaria-controls属性にも指定）-->
          <ul role="tablist">
            <li v-for="(value, name, index) in related_db" :key="index" role="presentation"><a class="g-btn" :id="name+'Tab'" :href="'#'+name+'Data'" role="tab" :aria-controls="name+'Data'" :aria-selected="[index ? 'false' : 'true']">{{ value }}</a></li>
          </ul>
        </div>
        <!--/DB一覧-->

        <!--↓↓最初のタブパネルはaria-expanded="true"にしてください-->
        <!--↓↓aria-labelledby属性に、対応するaタグのIDを記述します-->

        <!--タブパネル-->
        <template v-for="(detail, name, index) in details">
          <template v-if="detail.images">
            <!--画像ありタイトルありパターン-->
            <infoArea04 v-if="detail.fields[0].title" :key="index" :dbName="name" :records="detail.fields" :images="detail.images" :isFirst="index ? false : true" @parentFunc="openZoomModal">
            </infoArea04>
            <!--画像ありタイトルなしパターン-->
            <infoArea01 v-else :key="index" :dbName="name" :records="detail.fields" :images="detail.images" :isFirst="index ? false : true" @parentFunc="openZoomModal">
            </infoArea01>
          </template>
          <template v-else>
            <!--画像なしタイトルありパターン-->
            <infoArea02 v-if="detail.fields[0].title" :key="index" :dbName="name" :records="detail.fields" :isFirst="index ? false : true">
            </infoArea02>
            <!--画像なしタイトルなしパターン-->
            <infoArea03 v-else :key="index" :dbName="name" :records="detail.fields" :isFirst="index ? false : true">
            </infoArea03>
          </template>
        </template>
        <!--/タブパネル-->

      </div>
      <!--/データベース-->


      <!--関連する標本資料-->
      <div class="relation">
        <p class="g-h-2 g-h-sm">{{ $t('Detail.related_object') }}</p>
        <!--controls-->
        <div class="g-itemHead">
          <dl class="g-searchWith">
            <dt>{{ $t('Detail.by_checked_object') }}</dt>
            <dd>
              <button class="g-btn g-btn-lg g-btn-rensou" type="submit" @click.stop="getRensouResult">{{ $t('Form.submit_rensou') }}</button>
              <button class="g-btn g-btn-sm g-btn-reset" type="reset" @click.stop="clearIds">{{ $t('Form.clear_rensou') }}</button>
            </dd>
          </dl>
        </div>
        <!--/controls-->
        <!--list-->
        <ul class="g-itemList g-itemList-grid">
          <li v-for="object in summary.related" :key="object.num" class="g-itemList_el" aria-checked="false">
            <p class="g-itemList_img" aria-hidden="true">
              <router-link :to="'/detail/'+object.num | lang" :style="'background-image:url('+object.thumbnail+')'"><span class="g-clip">{{ object.title }}</span></router-link>
            </p>
            <div class="g-itemList_info">
              <p class="g-itemList_h"><router-link :to="'/detail/'+object.num | lang">{{ object.title }}</router-link></p>
              <p>{{ $t("List.__id__", { value: object.num }) }}</p>
              <label class="g-itemList_check">
                <input class="g-clip" type="checkbox" :checked="rensouChecked(object.num)" @click="checkRensou(object.num)"><i class="g-i g-i-check" aria-hidden="true"></i><span>{{ $t("Form.rensou_pickup") }}</span>
              </label>
            </div>
          </li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
          <li class="g-itemList_el" role="presentation"></li>
        </ul>
        <!--/list-->
      </div>
      <!--/関連する標本資料-->
    </main>

    <modal name="zoom-image-modal" :draggable="false" :resizable="false" :adaptive="true" :width="'90%'" :maxWidth="980" :height="'90%'" :maxHeight="800" :overlayTransition="'none'">
      <div class="modal-body">
        <div class="zoom-image" :style="'background-image:url('+this.activeImage+')'"></div>
        <button v-on:click="closeZoomModal">閉じる</button>
      </div>  
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import mainMixin from '@/mixins/mainMixin.js'
import i18n from '@/i18n.js'
import { Backend } from '@/ajax/Backend'
import VModal from 'vue-js-modal'
const Detail = Backend.get('detail')

Vue.use(VModal);

import breadcrumb from '@/components/breadcrumb.vue'
import infoArea01 from '@/components/infoArea01.vue'
import infoArea02 from '@/components/infoArea02.vue'
import infoArea03 from '@/components/infoArea03.vue'
import infoArea04 from '@/components/infoArea04.vue'
import galleryCarousel from '@/components/galleryCarousel.vue'

export default {
  name: 'Detail',
  mixins: [ mainMixin ],
  components: {
    breadcrumb,
    infoArea01,
    infoArea02,
    infoArea03,
    infoArea04,
    galleryCarousel
  },
  props: {
    id: { type: String, required: true }
  },
  data () {
    return {
      total: 0,
      summary: {},
      details: {},
      searchRequest: {
        fulltext: '',
        dbs: [],
        id: '',
        name: '',
        age: '',
        area: '',
        nation: '',
        owc: '',
        ocm: '',
        fyear: '',
        page: 1
      },
      rensouRequest: {
        freetext: '',
        ids: [],
        lang: '',
        page: 1
      },
      refreshRensouRequest: {
        ids: [],
      },
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 12,
        navigation: {
          nextEl: '.gallery_carousel_next',
          prevEl: '.gallery_carousel_prev'
        }
      },
      go_back_to: '',
      activeImage: ''
    }
  },
  filters: {
    // 配列になっている値の結合
    join (val) {
      if (Array.isArray(val)) {
        return val.length ? val.join(', ') : "-"
      } else {
        return val ? val : "-"
      }
    },
    // 英語ページの場合は英語ページへのリンクにする
    lang (path) {
      return i18n.locale == 'en' ? '/en'+path : path
    }
  },
  computed: {
    // パン屑リスト
    pathList: function() {
      return [
        { path: '/', text: 'Site.home' },
        { path: this.go_back_to? this.go_back_to : '/search/', text: 'Search.title' },
        { path: '/detail/'+this.id, text: this.summary.fields ? this.summary.fields.__title__ : '' },
      ]
    },
    // 現在の検索条件ハッシュ
    current_q: function() {
      if (this.$store.getters.current_q) {
        return this.$store.getters.current_q
      } else {
        return this.$route.query.q ? this.$route.query.q : ''
      }
    },
    // 概要情報の表示用
    summary_fields: function() {
      const items = {}
      if (this.summary.fields) {
        Object.keys(this.summary.fields).forEach(function (key) {
          const exclude_fields = ['__title__', '__id__', 'name']
          if (exclude_fields.indexOf(key) < 0) {
            items[key] = this.summary.fields[key]
          }
        }.bind(this));
      }
      return items
    },
    // 関連する索引語の表示用
    related_index: function() {
      const index = []
      if (this.summary.indices) {
        Object.keys(this.summary.fields).forEach(function (key) {
          const exclude_fields = ['__title__', '__id__', 'name', 'id']
          if (exclude_fields.indexOf(key) < 0) {
            index.push({field: key, value: this.summary.fields[key]})
          }
        }.bind(this));
      }
      return index
    },
    // データベース一覧の表示用
    related_db: function() {
      const dbs = {}
      if (this.details) {
        Object.keys(this.details).forEach(function (key) {
          dbs[key] = this.details[key].databaseName
        }.bind(this));
      }
      return dbs
    },
  },
  // このページに来る前の処理
  beforeRouteEnter (to, from, next) {
    next()
  },
  // このページ内でパラメータが変わった時の処理
  beforeRouteUpdate (to, from, next) {
    if (to.params.id != from.params.id) {
      this.getDetail(to.params.id)
    }
    next()
  },
  // ページ作成時の処理
  created: function() {
    if(this.$store.getters.current_q) {
      let param = this.$store.getters.current_q
      this.go_back_to =  '/search/?' + Object.keys(param).map(function(key){ return key+"="+ param[key] }).join("&")
    }
    this.getDetail(this.id)
  },
  methods: {
    // 資料詳細情報の取得（API）
    getDetail(id) {
      let params = {}
      if (this.current_q) {
        const queries = this.$store.getters.queries
        if (queries) {
          params = queries[this.current_q]
          if (params) {
            if (params.freetext || params.ids) {
              this.rensouRequest = Vue.util.extend({}, params)
            } else {
              this.searchRequest = Vue.util.extend({}, params)
            }
          } else {
            params = {}
          }
        }
      }
      params.lang = i18n.locale
      Detail.get(id, params)
        .then(function(response) {
           if (!response.data.info) {
             console.log(response.data)
           } else if (response.data.info.status === 'failure') {
             console.log(response.data.info.message)
           } else {
             this.total = response.data.info.total
             this.summary = response.data.summary
             this.details = response.data.details

             // 画像に空データが存在する場合がある
             let images = this.summary.images
             let i = 0
             for(i; i < images.length; i++) {
               if(!images[i].url) {
                 images = images.splice(i, 1)
                 i --
               }
             }
           }
        }.bind(this))
        .catch(err => console.log(err))
    },
    // 一致検索条件を指定して検索結果一覧ページへ（関連する索引語）
    getSearchResult(id, value) {
      const request = {}
      if(Array.isArray(value)) {
        request[id] = value.join(' ')
      } else {
        request[id] = value
      }
      request.exact_fields = id
      request.page = 1
      if (i18n.locale == 'en') {
        this.$router.push({ path: '/en/search', query: request })
      } else {
        this.$router.push({ path: '/search', query: request })
      }
    },
    // 連想検索条件を指定して検索結果一覧ページへ（関連する標本資料）
    getRensouResult() {
      const request = {}
      request.ids = this.refreshRensouRequest.ids
      request.ids.push(this.id)
      request.page = 1
      if (i18n.locale == 'en') {
        this.$router.push({ path: '/en/search', query: request })
      } else {
        this.$router.push({ path: '/search', query: request })
      }
    },
    // 連想検索条件にする資料のチェック用
    checkRensou(id) {
      if (this.refreshRensouRequest.ids.includes(id)) {
        this.refreshRensouRequest.ids = this.refreshRensouRequest.ids.filter((item) => item != id)
      } else {
        this.refreshRensouRequest.ids.push(id)
      }
    },
    // 連想検索条件になっている資料かどうかの確認用
    rensouChecked(id) {
      if (this.refreshRensouRequest.ids.includes(id)) {
        return true
      }
      return false
    },
    // 連想検索条件になっている資料のクリア
    clearIds() {
      this.refreshRensouRequest.ids = []
    },
    // 配列になっている値の結合
    join (val) {
      if (Array.isArray(val)) {
        return val.length ? val.join(', ') : "-"
      } else {
        return val ? val : "-"
      }
    },
    // Modal
    openZoomModal(target) {
      this.activeImage = target
      this.$modal.show('zoom-image-modal')
    },
    closeZoomModal() {
      this.$modal.hide('zoom-image-modal')
    }
  },
  head: {
    title: function () {
      return {
        inner: i18n.t('Site.title') + ' ' + this.id,
      }
    },
    meta: function () {
      return [
        { property: 'og:title', content: i18n.t('Site.title') + ' ' + this.id },
      ]
    }
  }
}
</script>
